const conceptMapPin = (() => {
  const pageConcept = (document.getElementById("pageConcept") != null);
  if (pageConcept) {


    // let sW = window.innerWidth;
    // let sH = window.innerHeight;


    let jsSecMap = document.getElementById("jsSecMap")
    let mapBox = jsSecMap.querySelector(".js-map-box")


    document.addEventListener("DOMContentLoaded", () => {

      ScrollTrigger.create({
        trigger: mapBox,
        start: "top top",
        endTrigger: jsSecMap,
        end: "bottom bottom",
        pin: true,
        // markers: true,
      });

    });



  }
})()
export default conceptMapPin;